<template lang="pug">
  .component-backoffice-common-cost-type-list.row.column
    .row.column
      base-list(:component="component", :dataLoader="dataLoader", :showPerPageSelect="true")
</template>

<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import BaseList from './BaseList'


  export default {
    name: 'CommonCostTypeList',
    components: {
      BaseList,
    },
    data: function () {
      return {
        component: require('src/components/backoffice/CommonCostType'),
        items : null,
      }
    },
    created() {
    },
    methods: {
      dataLoader(callback) {
        KeplerBackofficeSdk.commonCostType.list.all(1,25,(data) => {
           callback(data)

        })
      },

    },
  }
</script>

<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// CommonCostTypeList.vue?72725598